import { useEffect, useState } from "react";
import IRepertoireComponentDataItem from "../../redux/types/IRepertoireComponentDataItem";
import { AI, SIMPLE } from "../Consts";
import { SearchRequests } from "../services/SearchRequests";
import { AI_SEARCH_CONFIGURATION_GROUP, CONFIGURATION_PARAMETER_ENABLE_GENIE_AI_SEARCH } from "../ConfigurationConsts";

export const getAiSearchOption = (
    searchViewData: IRepertoireComponentDataItem,
    showAiOption: boolean
) => {
    if (!showAiOption) {
        return { option3: undefined, option3Label: undefined };
    }

    const option3Label = searchViewData?.fields?.find((field) => field.name === AI)?.data || AI;
    return { option3: AI, option3Label };
};

export const getAiSearchEnabled = async () => {
    const value = await SearchRequests.getConfigurationParameter(
        CONFIGURATION_PARAMETER_ENABLE_GENIE_AI_SEARCH,
        AI_SEARCH_CONFIGURATION_GROUP
    );
    return value === true || value === "true" || value === 1 || value === "1";
};

export const useAiSearchOption = (
    searchViewData: IRepertoireComponentDataItem,
    searchType: string,
    setSearchType: (value: string) => void
) => {
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        let cancelled = false;

        const load = async () => {
            try {
                const value = await getAiSearchEnabled();
                if (cancelled) {
                    return;
                }
                setEnabled(value);
                if (!value && searchType === AI) {
                    setSearchType(SIMPLE);
                }
            } catch {
                if (cancelled) {
                    return;
                }
                setEnabled(false);
                if (searchType === AI) {
                    setSearchType(SIMPLE);
                }
            }
        };

        load();

        return () => {
            cancelled = true;
        };
    }, [searchType, setSearchType]);

    return {
        ...getAiSearchOption(searchViewData, enabled)
    };
};
